import { useContext, useState } from "react";
import './select-language.scss';
import { LanguageContext } from "../../../providers/LanguageProvider";
import { LANGUAGES } from "../../../utils/constants/languages";
import { FaChevronDown } from "react-icons/fa";
import FLAG_MAP from "../../../utils/constants/flags";

export function SelectLanguage(){

    const [isCollapsed, setIsCollapsed] = useState(false);
    const  { language,setLanguage} = useContext(LanguageContext);
    function setLang(code:string){
        setLanguage(code);
        setIsCollapsed(false);
    }

    function displayLanguage(){
        setIsCollapsed(!isCollapsed);

    }
  
    return(
        <>
            <div className="select-lang-container">
                <div className='select-control flex align-center gap'>
                    <img src={FLAG_MAP[language]} className='icon-img' alt='select lang' title='change language' width={32} height={32}/> 
                    <span onClick={displayLanguage} className ='flex align-center gap-xs'><FaChevronDown /></span> 
                </div>
                    
                <ul className={`select-lang-list ${isCollapsed? 'collapsed' :''}`}>
                    {LANGUAGES.map((lang,k)=>{
                        const {code,label,enabled} = lang;
                        if (!enabled) return;
                        return <li key={k} onClick={()=>setLang(code)}><img src={FLAG_MAP[code]} width={32} height={32}/> {label}</li>              
                    })}
                
                </ul>
            </div>
        </>
    )
}